import React from 'react';

const SimpleLayout = ({ children }) => {
  return (
    <main>{children}</main>
  );
};

export default SimpleLayout;
